import CategoriesBar from "../../../globalcomponents/navbar/categorieslist/CategoriesBar";
import NavbarTwo from "../../../globalcomponents/navbar/NavbarTwo";

const DeliveryFeedBack = () => {
  return (
    <>
      <div className=" display-max">
        <NavbarTwo />
        <CategoriesBar />
        <div className=" container mx-auto w-70 mt-3">
          <div className=" d-flex justify-content-between align-items-center lh-1">
            <div>
              <h2 className="s text-dark">Delivery Feedback</h2>
            </div>
          </div>
          <div className=" border p-3 mt-3 mb-3 border-radius-2xl">
            <div className="mt-0 mb-3">
              <div className="border-bottom ">
                <div className=" d-flex justify-content-between align-items-start p-2 gap-5">
                  <div className=" text-center">
                    <h6>Product</h6>
                    <div>
                      <img
                        className="seller-feedback-images"
                        src="../../assets/img/women/women-4.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="w-100">
                    <div>
                      <b className=" text-black fw-normal text-lg lh-sm">
                        GRECIILOOKS Women’s Tops – Crop Top, Loose Fit Oversized
                        Shirts & Stylish Korean Tank Tops for Summer Wear
                        (Available in Plus Size)
                      </b>
                      <div className=" mt-1">
                        <a
                          href="/MaxProductReview"
                          className=" text-success text-sm fw-normal"
                        >
                          Write a product review{" "}
                        </a>
                      </div>
                    </div>
                    <div className=" lh-base mt-3">
                      <b className=" text-bold fs-3 text-success">Delivered</b>
                      <div className=" mt-1">
                        <b className=" text-dark fw-normal">
                          Package was delivered on Monday 05 July, 2025.
                        </b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b className=" text-dark fs-5">Rate your delivery experience</b>
            <div className="d-flex gap-1">
              <a href=".">
                <span>
                  <i className="bi bi-star fs-1"></i>
                </span>
              </a>
              <a href=".">
                <span>
                  <i className="bi bi-star fs-1"></i>
                </span>
              </a>
              <a href=".">
                <span>
                  <i className="bi bi-star fs-1"></i>
                </span>
              </a>
              <a href=".">
                <span>
                  <i className="bi bi-star fs-1"></i>
                </span>
              </a>
              <a href=".">
                <span>
                  <i className="bi bi-star fs-1"></i>
                </span>
              </a>
            </div>
            <div className="mt-3 mb-0">
              <div className="justify-content-start align-items-start p-3">
                <div>
                  <div className="mt-0">
                    <b className=" text-bold fs-6 text-dark">What went well?</b>
                    <div className=" d-flex justify-content-start align-items-center gap-4 mt-2">
                      <div>
                        <div className="form-check mb-0">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="customRadio1"
                          />
                          <label className="custom-control-label text-dark fw-bold">
                            Delivery associate
                          </label>
                        </div>
                      </div>
                      <div>
                        <div className="form-check mb-0">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="customRadio1"
                          />
                          <label className="custom-control-label text-dark fw-bold">
                            Packaging
                          </label>
                        </div>
                      </div>
                      <div>
                        <div className="form-check mb-0">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="customRadio1"
                          />
                          <label className="custom-control-label text-dark fw-bold">
                            Other
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="justify-content-start align-items-start p-3">
                <div>
                  <div className="mt-0">
                    <b className=" text-bold fs-6 text-dark">
                      Tell us more about the delivery associate:
                    </b>
                    <div className=" d-flex justify-content-start align-items-center gap-4 mt-2">
                      <div>
                        <div className="form-check mb-0">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="customRadio1"
                          />
                          <label className="custom-control-label text-dark fw-bold">
                            Polite behaviour
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="justify-content-start align-items-start p-3">
                <div>
                  <div className="mt-0">
                    <b className=" text-bold fs-6 text-dark">
                      Tell us more about the packaging:
                    </b>
                    <div className=" d-flex justify-content-start align-items-center gap-4 mt-2">
                      <div>
                        <div className="form-check mb-0">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="customRadio1"
                          />
                          <label className="custom-control-label text-dark fw-bold">
                            Sturdy packaging
                          </label>
                        </div>
                      </div>
                      <div>
                        <div className="form-check mb-0">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="customRadio1"
                          />
                          <label className="custom-control-label text-dark fw-bold">
                            Appropriate packaging
                          </label>
                        </div>
                      </div>
                      <div>
                        <div className="form-check mb-0">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="customRadio1"
                          />
                          <label className="custom-control-label text-dark fw-bold">
                            100% recyclable packaging
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <b className=" text-bold fs-6 text-dark">Comments :</b>
              <div className="input-group input-group-outline">
                <textarea
                  className="form-control fs-6"
                  rows={7}
                  placeholder="Tell us more"
                ></textarea>
              </div>
              <p className=" text-xxs">
                Your feedback will be used to identify improvements but not
                responded to directly. If you need immediate assistance with an
                order, contact us.
              </p>
              <div className=" d-flex justify-content-center align-items-center mt-3">
                <button className=" btn btn-yellow btn-lg">
                  Submit Feedback
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeliveryFeedBack;
